import React from 'react';
import { Spinner } from 'react-bootstrap';
import { usePatientService } from '~/services';
import { enumValue, gapIsAddressed, gapIsPending } from '~/util';

interface QualityClearProps {
    gap: GapType;
    patientId: number;
    tab: string;
    rolePermission: boolean;
    setDisabled: (x: boolean) => void;
    disabled: boolean;
    onSuccess: () => void;
    isRestarting: boolean;
    setIsRestarting: (x: boolean) => void;
}
export function QualityClear({
    gap,
    patientId,
    tab,
    rolePermission,
    disabled,
    setDisabled,
    onSuccess,
    isRestarting,
    setIsRestarting,
}: QualityClearProps) {
    const { deleteSubmissionAnswer, updateQualityGap } = usePatientService();
    const [saving, setSaving] = React.useState(false);
    const shouldDisplayRestart =
        (gapIsAddressed(gap) &&
            gap.submission_answer?.status !== enumValue(['submission', 'status', 'New'])) ||
        !gap.submission_answer;

    async function handleClear() {
        if (shouldDisplayRestart) {
            setIsRestarting(true);
            return;
        }
        try {
            setSaving(true);
            setDisabled(true);
            if (enumValue(['submission', 'status', 'New']) === gap.submission_answer?.status) {
                // Delete submission_answer
                await deleteSubmissionAnswer(
                    enumValue(['gap', 'type', 'Quality Gap']) as number,
                    gap.id,
                    gap.submission_answer.id
                );
            } else {
                await updateQualityGap(gap.id, patientId, {
                    submission_answer: null,
                    updated_at: gap.updated_at,
                });
            }
            onSuccess();
        } catch (e) {
            setSaving(false);
            setDisabled(false);
        }
    }

    if (
        tab !== 'Measures' ||
        !rolePermission ||
        isRestarting ||
        (!(gapIsPending(gap) && gap.submission_answer) &&
            !(gapIsAddressed(gap) && gap.measure?.is_manual_add_compatible))
    )
        return null;

    return (
        <div className="text-center">
            <button
                className="btn btn-warning"
                type="button"
                onClick={handleClear}
                disabled={disabled}
            >
                {saving && <Spinner animation="border" role="status" size="sm" className="me-1" />}
                {shouldDisplayRestart ? 'Restart' : 'Clear'}
            </button>
        </div>
    );
}
